module.exports = new __parcel__URL__("mainframe_level_6_v2.4bfb903a.png").toString();